import { Box, Flex, SimpleGrid } from '@chakra-ui/react';

import CardSkeleton from './CardSkeleton';
import CardHeadSkeleton from './CardHeadSkeleton';
import SkeletonComponent from '@components/skeleton';
import { IterationComponent } from '@components/functionComponent';

const ParahubDetailSkeleton = () => {
    return (
        <Box>
            <CardHeadSkeleton mb={'24px'} />

            <CardSkeleton mb={'24px'}>
                <SimpleGrid columns={4} spacing={'24px'}>
                    <IterationComponent
                        arr={[1, 2, 3, 4]}
                        render={() => (
                            <Box>
                                <SkeletonComponent width="100%" maxWidth={'80px'} height={'20px'} mb={'4px'} />
                                <SkeletonComponent width="100%" maxWidth={'120px'} height={'20px'} />
                            </Box>
                        )}
                    />
                </SimpleGrid>
            </CardSkeleton>
            <CardSkeleton mb={'24px'}>
                <SimpleGrid columns={4} spacing={'24px'}>
                    <IterationComponent
                        arr={[1, 2, 3, 4]}
                        render={() => (
                            <Box>
                                <SkeletonComponent width="100%" maxWidth={'120px'} height={'20px'} mb={'4px'} />
                                <SkeletonComponent width="100%" height={'40px'} />
                            </Box>
                        )}
                    />
                </SimpleGrid>
            </CardSkeleton>
            <CardSkeleton>
                <SimpleGrid columns={3} spacing={'24px'} mb={'24px'}>
                    <IterationComponent
                        arr={[1, 2, 3, 4, 5, 6]}
                        render={(params) => {
                            if (params == 1) {
                                return (
                                    <Box>
                                        <SkeletonComponent width="100%" maxWidth={'80px'} height={'20px'} mb={'4px'} />
                                        <Flex gap={'12px'}>
                                            <SkeletonComponent width="100%" height={'40px'} />
                                            <SkeletonComponent width="100%" height={'40px'} />
                                        </Flex>
                                    </Box>
                                );
                            }

                            return (
                                <Box>
                                    <SkeletonComponent width="100%" maxWidth={'80px'} height={'20px'} mb={'4px'} />
                                    <SkeletonComponent width="100%" height={'40px'} />
                                </Box>
                            );
                        }}
                    />
                </SimpleGrid>

                <SkeletonComponent width="100%" maxWidth={'80px'} height={'20px'} mb={'4px'} />
                <SkeletonComponent width="100%" height={'40px'} />
            </CardSkeleton>
        </Box>
    );
};

export default ParahubDetailSkeleton;
